module.exports = __webpack_public_path__ + "assets/img/windows-3.e4981211.jpg";